<template>
    <div class="topBg">
        <img src="@/assets/home/background1.png" alt="">
        <div class="contents">
            <p class="title">{{titles}}</p>
            <p v-for="item,index in smalls" :key="index" class="small">{{item}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titles:{
            type: String,
            default:""
        },
        smalls:{
            type: Array
        }
    },
    data() {
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.topBg{
    text-align: center;
    position: relative;
    width: 100%;
    min-height: 180px;
    max-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    .contents{
        position: absolute;
        color: #fff;
    }
    .title{
        font-size: 24px;
        margin-bottom: 20px;
    }
    .small{
        line-height: 30px;
    }
    img {
        width: 100%;
        min-height: 180px;
        max-height: 260px;
    }
}
</style>
